import { render, staticRenderFns } from "./BrandPromotion.vue?vue&type=template&id=e4e5caf4&scoped=true&"
import script from "./BrandPromotion.vue?vue&type=script&lang=js&"
export * from "./BrandPromotion.vue?vue&type=script&lang=js&"
import style0 from "./BrandPromotion.vue?vue&type=style&index=0&id=e4e5caf4&lang=scss&scoped=true&"
import style1 from "./BrandPromotion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e5caf4",
  null
  
)

export default component.exports